import * as React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { isUseHelpCenterRefresh } from '@helpcenter/feature-flags';
import { getHelpCenterBanner, getHelpCenterBrandingLoader } from 'state/selectors/help-center';
import { getShown as getSearchShown } from 'state/selectors/search';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { useCachedUrl } from '@atlassian/help-center-common-util/use-cached-url';
import { BannerWithGridLayoutDumb } from '../banner-with-grid-layout-dumb';
import type { Props } from '../banner-with-paper-layout-dumb';
import { BannerWithPaperLayoutDumb } from '../banner-with-paper-layout-dumb';
import { withLayoutRoute } from '../with-layout-route';

export const BannerWithPaperLayout = (props: Props) => {
    const { children, helpCenterBanner, ...restProps } = props;

    // Use the useCachedUrl hook to handle the banner URL
    const { cachedBannerUrl, isLoading: isBannerImageLoading } = useCachedUrl(helpCenterBanner);

    if (isUseHelpCenterRefresh()) {
        return (
            <React.Fragment>
                {FeatureGates.checkGate('add_ufo_holds_to_help_center_banner') && (
                    <UFOLoadHold name="banner-with-paper-layout-image-loader" hold={isBannerImageLoading} />
                )}
                <BannerWithGridLayoutDumb {...restProps} helpCenterBanner={cachedBannerUrl || undefined}>
                    {children}
                </BannerWithGridLayoutDumb>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {FeatureGates.checkGate('add_ufo_holds_to_help_center_banner') && (
                <UFOLoadHold name="banner-with-paper-layout-image-loader" hold={isBannerImageLoading} />
            )}
            <BannerWithPaperLayoutDumb {...restProps} helpCenterBanner={cachedBannerUrl || undefined}>
                {children}
            </BannerWithPaperLayoutDumb>
        </React.Fragment>
    );
};

const selector = createSelector(
    getHelpCenterBanner,
    getSearchShown,
    getHelpCenterBrandingLoader,
    (helpCenterBanner, searchShown, isBrandingLoaded) => ({
        helpCenterBanner,
        searchShown,
        isBrandingLoaded,
    })
);

const ConnectedBannerWithPaperLayout = connect(selector)(BannerWithPaperLayout);
export const BannerWithPaperLayoutRoute = withLayoutRoute(ConnectedBannerWithPaperLayout);
export default ConnectedBannerWithPaperLayout;
